import { useI18n } from '../composables/i18n.composable';
import { infuse } from '../ioc-config';
import Vehicle from '../models/vehicle.model';
import { getStorageItem } from './persistence.util';

export function getTranslationFallback(key: string, displayName: string): string {
  const { t } = useI18n();
  const formattedKey = key.replace(' ', '_');

  const phraseDisplayName: string = t(formattedKey, {
    nsSeparator: false,
  });

  return getStorageItem<string>('cimode')
    ? // Display formatted key for CIMODE
      formattedKey
    : phraseDisplayName && phraseDisplayName !== formattedKey
    ? // Display translated key
      phraseDisplayName
    : // Default BE fallback
      displayName;
}
export function getTranslationUnitFallback(value: number, key: string, displayName: string): string {
  let { locale } = infuse('config');
  const { shopCountry } = infuse('config');
  const { t } = useI18n();
  const formattedKey = key.replace(' ', '_');
  const phraseFormattedUnit: string = t(formattedKey);

  // EMHHB-844: Extrawurst for AT market: unfortunately they want to display a '.' as delimiter instead of ' ',
  // so we have to override the locale for the Intl.NumberFormat call below
  if (shopCountry === 'AT') {
    locale = 'de-DE';
  }

  return getStorageItem<string>('cimode')
    ? // Display formatted key for CIMODE
      formattedKey
    : phraseFormattedUnit && phraseFormattedUnit !== formattedKey
    ? // Display translated key with INTL number format
      `${new Intl.NumberFormat(locale).format(value)} ${phraseFormattedUnit}`
    : // Default BE fallback
      displayName;
}

export function translateProductEnums(product: Vehicle) {
  const enumKeys: Array<keyof Pick<Vehicle, 'bodyType' | 'fuelType' | 'driveType' | 'gearBox'>> = [
    'bodyType',
    'fuelType',
    'driveType',
    'gearBox',
  ];

  enumKeys.forEach((key) => {
    if (product[key]?.name) {
      product[key].name = getTranslationFallback(
        `dcp.product.attribute.${key}.value.${product[key].code}`,
        product[key].name as string,
      );
    }

    product.transmission = product.gearBox?.name as string;
  });

  return product;
}

export const isKeyTranslated = (key: string): boolean => {
  const { t } = useI18n();
  const translatedText = t(key);

  return translatedText.replace(/\s/g, '') !== '';
};
